const SQL_IDENTIFIER_ALLOWED_CHARS = /[^A-Za-z0-9_]/g
const SQL_IDENTIFIER_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/

export function sanitizeSqlIdentifierInput(value: string): string {
  return String(value || '').replace(SQL_IDENTIFIER_ALLOWED_CHARS, '')
}

export function isValidSqlIdentifier(value: string): boolean {
  const trimmed = String(value || '').trim()
  if (!trimmed) return false
  return SQL_IDENTIFIER_PATTERN.test(trimmed)
}
